import { useAppSelector } from '../../../../../../store/hooks';
import { getAreReviewsFiltersVisibleSelector } from '../../selectors/get-are-reviews-filters-visible.selector';

export const useAreReviewsFiltersVisible = (): boolean => {
  return useAppSelector(getAreReviewsFiltersVisibleSelector);
};
